export enum RecordFieldSyncStrategy {
  CreatedOnly = 'CreatedOnly',
  CreatedOrUpdated = 'CreatedOrUpdated',
}
